<template>
  <div>
    <!--底部-->
    <footer class="footer_wrapper">
      <!-- <div class="home_item wow fadeInDown" data-wow-delay="0.1s">
        <h2>{{language.links}}</h2>
        <div class="cupboard">
          <div class="full links clear_float">

            <div class="item"><a href="https://www.schneider-electric.cn/zh/" target="_blank"><span><img
                    src="../../static/images/shinaide.png" alt="" /></span></a></div>

            <div class="item"><a href="https://www.siemens.com/cn/zh/home.html" target="_blank"><span><img
                    src="../../static/images/ximenzi.png" alt="" /></span></a></div>

            <div class="item"><a href="https://www.alstom.com" target="_blank"><span><img
                    src="../../static/images/alstom.png" alt="" /></span></a></div>

          </div>
        </div>
      </div> -->

      <section class="lianxi">
        <div class="b-nav wow fadeInDown" data-wow-delay="0.1s">
          <router-link to="index">{{language.index}}</router-link>
          <router-link to="about">{{language.about}}</router-link>
          <router-link to="product">{{language.product}}</router-link>
          <router-link to="career">{{language.career}}</router-link>
          <router-link to="achievement">{{language.achievement}}</router-link>
          <router-link to="contact">{{language.contact}}</router-link>
        </div>
        <p class="copy">{{language.copyright}} </p>
        <p class="copy-1"> <a href="https://beian.miit.gov.cn/"
            style=" color:#8b939d;text-decoration:none;text-align: center;"
            target="_blank">{{language.icp}}</a></p>

      </section>
    </footer>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    computed:{
      language() {
        let footer = this.$store.state.language.footer
        return footer
      }
    },
    methods: {},
    created() {},
    destroyed() {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/footer.vue